import controller from './new-products.controller';
import templateBase from './templates/new-products-base.view.html';

let NewProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default NewProductsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/new-products/new-products.component.js
 **/